/** Socket.IO event names for admin and user chat. */

export const AdminChatSocketEvents = {
  JOIN: 'adminChat:join',
  JOINED: 'adminChat:joined',
  SEND_MESSAGE: 'adminChat:sendMessage',
  MESSAGE: 'adminChat:message',
  INBOX_UPDATE: 'adminChat:inboxUpdate',
  LEAVE: 'adminChat:leave',
  UNSEEN_COUNT: 'adminChat:unseenCount',
  ERROR: 'adminChat:error',
} as const;
